import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class SessionStorageService {
    getItem<T = any>(key: string): Observable<T | null> {
        return new Observable<T | null>((observer) => {
            try {
                const storedValue = window.sessionStorage.getItem(key);
                observer.next(storedValue === null ? null : this.deserialize<T>(storedValue));
                observer.complete();
            } catch (error) {
                observer.error(error);
            }
        });
    }

    setItem(key: string, value: any): Observable<void> {
        return new Observable<void>((observer) => {
            try {
                window.sessionStorage.setItem(key, JSON.stringify(value));
                observer.next();
                observer.complete();
            } catch (error) {
                observer.error(error);
            }
        });
    }

    clear(): Observable<void> {
        return new Observable<void>((observer) => {
            try {
                window.sessionStorage.clear();
                observer.next();
                observer.complete();
            } catch (error) {
                observer.error(error);
            }
        });
    }

    private deserialize<T>(storedValue: string): T {
        try {
            return JSON.parse(storedValue) as T;
        } catch {
            return storedValue as any as T;
        }
    }
}
